import { NavLink } from 'react-router-dom';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  Switch,
  TextField,
  Typography
} from '@mui/material';
import { ChangeEvent, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { AppRootState } from '../../app/store';
import { checkAutoLogin } from '../Login/auth-reducer';
import { UserLocationStateType } from './UserItem';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { getLocation, getProjectNamesFromCookies } from '../../app/cookies';
import { AlertDelete } from '../common/AlertDeleteAccount';
import { AlertDialogPassword } from './PasswordSettingsDialog';
import { deleteUserTC, updateUserTC, UserType } from './users-reducer';


export const UserData = () => {
  const location = useLocation()
  const state = location.state as UserLocationStateType
  const user: UserType = state.user
  const isLoggedIn = useSelector<AppRootState, boolean>(state => state.auth.isLoggedIn)
  const navigate = useNavigate();
  const [projectName, setProjectName] = useState("")
  const [values, setValues] = useState({ ...user })
  const [checkbox, setCheckbox] = useState(user.isActive)
  let stateLabel
  user.isActive ? stateLabel = 'Active' : stateLabel = ''
  const [label, setLabel] = useState(stateLabel)
  const roles = user.roles
  const isAdmin = user.isAdminRole
  const [adminRole, setAdminRole] = useState(user.roles.includes("Administrator"))
  const [itRole, setITRole] = useState(user.roles.includes("IT"))
  const [serviceRole, setServiceRole] = useState(user.roles.includes("Servicedesk"))
  let newRoles = []
  let rolesForSend
  const dispatch = useDispatch()

  const usersFromState = useSelector<AppRootState, Array<UserType>>(state => state.users.users)
  const userFromState = usersFromState.find(u => u.id === user.id)
 

  useEffect(() => {
    let token = checkAutoLogin(dispatch, false)
    if (token === null && isLoggedIn === false) {
      return navigate('/login')
    } else {
      if (token !== null && isLoggedIn === false) {
        return navigate(`/accountsList`)
      }
    }

    const location = getLocation()
    setProjectName(location.projectName)
  }, [isLoggedIn]);

  let projectNames: Array<{projectName: string, projectId: number}> = getProjectNamesFromCookies()
  if(!projectNames){
    projectNames = [] as Array<{projectName: string, projectId: number}>
  }
  let prArray = user.projects.map(pr => pr.projectName)
  const [personName, setPersonName] = useState<string[]>(prArray);

  newRoles[0] = adminRole ? "Administrator" : ""
  newRoles[1] = itRole ? "IT" : ""
  newRoles[2] = serviceRole ? "Servicedesk" : ""
  rolesForSend = newRoles.filter(role => role !== '')

  let reqBody = {
    ...values,
    isActive: checkbox,
    roles: rolesForSend,
    projects: personName
  }

  let isSaveButtonDisabled: boolean
  user.userName === values.userName && JSON.stringify(prArray) === JSON.stringify(reqBody.projects) && user.firstName === values.firstName && user.lastName === values.lastName && user.email === values.email 
  && user.description === values.description && user.isActive === reqBody.isActive && user.roles[0] === reqBody.roles[0]
    ? isSaveButtonDisabled = true
    : isSaveButtonDisabled = false

  async function updateUser() {
    await dispatch(updateUserTC({user: reqBody}))
    navigate(`/accountsList/${user.accountId}`, {state:{accountId: user.accountId}})
  }

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const handleChangeCheckbox = (event: ChangeEvent<HTMLInputElement>) => {
    setCheckbox(event.target.checked)
    event.target.checked ? setLabel('Active') : setLabel('')
  }

  const handleChangeAdmin = (event: ChangeEvent<HTMLInputElement>) => {
    setAdminRole(event.target.checked)
  }
  // const handleChangeIT = (event: ChangeEvent<HTMLInputElement>) => {
  //   setITRole(event.target.checked)
  // }
  const handleChangeServiceDesk = (event: ChangeEvent<HTMLInputElement>) => {
    setServiceRole(event.target.checked)
  }
  async function removeUser() {
   await dispatch(deleteUserTC({user}))
    navigate(`/accountsList/${user.accountId}`, {state: {accountId: user.accountId}})
  }

  const handleChangeSelect = (event: SelectChangeEvent<typeof personName>) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  return (
    <>
      
        <Container maxWidth={false}>
        <Grid container style={{ paddingTop: '70px', paddingBottom: '50px' }} spacing={3} alignItems="center">
        <Grid item xl={8} md={8} xs={6} style={{ paddingTop: '30px' }}>
          {/* <div className='addItemButton' style={{ padding: '5px', display: 'inline-flex', alignItems: 'center', }} 
          onClick={(e) => navigate(`/accountsList/${user.accountId}`, {state: {accountId: user.accountId}})} >
            <KeyboardReturnIcon fontSize='medium' style={{ color: 'grey' }} />
            <span>Back to Account </span>
          </div> */}
            <Button onClick={(e) => navigate(`/accountsList/${user.accountId}`, {state: {accountId: user.accountId}})} color='info' className='addItemButton' startIcon={<KeyboardReturnIcon style={{ color: 'grey' }} fontSize='medium' />}>
            Back to account
          </Button>
        </Grid>
        <Grid item xl={2} md={2} xs={3}>
                  <Button style={{float: 'right'}}
                    color="info"
                    variant="contained"
                    onClick={updateUser}
                    disabled={isSaveButtonDisabled}
                  >
                    Save
                  </Button>
        </Grid>
        <Grid item xl={2} md={2} xs={3}>
              <AlertDelete deleteButtonText='delete user' remove={removeUser} name={`User ${user.firstName} ${user.lastName}`} />
        </Grid>
      </Grid>
          <Box sx={{ pt: 3 }}>
            {/* <Box sx={{ minWidth: 1050 }}> */}
            <Box>
              <form
                autoComplete="off"
                noValidate
              >
                <CardHeader
                  title={`User data`}
                />
                <Divider />
                <CardContent>
                  <Grid container spacing={3}>
                    <Grid item md={12} xs={12}>
                      <TextField 
                        fullWidth 
                        label="User name" 
                        name="userName" 
                        required 
                        variant="outlined"
                        onChange={handleChange}
                        value={values.userName}
                      />
                    </Grid>
                    <Grid item md={12} xs={12}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-multiple-checkbox-label">Project</InputLabel>
                      <Select
                        labelId="demo-multiple-checkbox-label"
                        id="demo-multiple-checkbox"
                        multiple
                        value={personName}
                        onChange={handleChangeSelect}
                        input={<OutlinedInput label="Project" />}
                        renderValue={(selected) => selected.join(', ')}
                        fullWidth
                      >
                        {projectNames.map((pr) => (
                          <MenuItem key={pr.projectId} value={pr.projectName}>
                            <Checkbox color='info' checked={personName.indexOf(pr.projectName) > -1} />
                            <ListItemText primary={pr.projectName} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                    <Grid item md={6} xs={6}>
                      <TextField fullWidth
                        label="Password"
                        name="password"
                        type="password"
                        //onChange={handleChange}
                        disabled={true}
                        required
                        value={values.password}
                        variant="outlined"
                      />
                    </Grid>
                   
                    <Grid
                      item
                      md={6}
                      xs={6}
                      style={{ position: 'relative' }}
                    >
                    <AlertDialogPassword user={user} />
                    </Grid>
                    <Grid
                      item
                      md={6}
                      xs={12}
                    >
                      <TextField
                        fullWidth
                        label="Name"
                        name="firstName"
                        onChange={handleChange}
                        required
                        value={values.firstName}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid
                      item
                      md={6}
                      xs={12}
                    >
                      <TextField
                        fullWidth
                        label="Last name"
                        name="lastName"
                        onChange={handleChange}
                        required
                        value={values.lastName}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid
                      item
                      md={12}
                      xs={12}
                    >
                      <TextField
                        fullWidth
                        label="Email"
                        name="email"
                        onChange={handleChange}
                        required
                        value={values.email}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid
                      item
                      md={12}
                      xs={12}
                    >
                      <TextField
                        fullWidth
                        label="Description"
                        name="description"
                        onChange={handleChange}
                        required
                        value={values.description}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xl={3} xs={12}><Typography> Roles: </Typography></Grid>
                    <Grid item xl={9} xs={12}>
                      <FormControlLabel control={<Checkbox name='Administrator' color='info' onChange={handleChangeAdmin} checked={adminRole} />} label="Administrator" />
                    </Grid>
                    <Grid
                      item
                      xl={3}
                      xs={12}>
                    </Grid>
                    <Grid
                      item
                      xl={9}
                      xs={12}>
                      <FormControlLabel control={<Checkbox color='info' name='Servicedesk' onChange={handleChangeServiceDesk} checked={serviceRole} />} label="Servicedesk" />
                    </Grid>
                    <Grid
                      item
                      xl={3}
                      xs={12}><Typography> Status : </Typography>
                    </Grid>
                    <Grid
                      item
                      xl={9}
                      xs={12}>
                      <FormControlLabel control={<Switch name="isActive" checked={checkbox} color='info' onChange={handleChangeCheckbox} />} label={label} />
                    </Grid>
                  </Grid>
                </CardContent>
                <Divider />

              </form>
            </Box>
          </Box>
        </Container>
    </>
  );
}
